import {
  TOGGLE_RESTRICTED,
  INIT_UI_RESTRICTED,
  TOGGLE_UI_RESTRICTED,
  RESET_UI_RESTRICTED,
} from './constants'

export const initUiRestricted = (initValue) => {
  return {
    type: INIT_UI_RESTRICTED,
    initValue,
  }
}

export const toggleRestricted = () => {
  return {
    type: TOGGLE_RESTRICTED,
  }
}

export const toggleUiRestricted = () => {
  return {
    type: TOGGLE_UI_RESTRICTED,
  }
}

export const resetUiRestricted = () => {
  return {
    type: RESET_UI_RESTRICTED,
  }
}
